// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_iv-0";
export var fileCarousel = "_iv-2";
export var removeFileButton = "_iv-1";